import React, { useRef } from "react";
import { Form, Input, Button, Select, Card, Row, Col, Table } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Link } from "react-router-dom";
import Footer from "Common/Footer";
import useHiring from "Hooks/AdminHooks/useHiring";
import {
  usStates,
  COMPENSATION_RANGES,
  EXPERIENCE_LEVELS,
  EMPLOYMENT_TYPES,
} from "Common/Static_Property_Data";

const { Option } = Select;

const JobPostingForm = () => {

    const quillRef = useRef(null);

  const {
    handleBackToList,
    handleAddJob,
    form,
    jobPostings,
    showForm,
    loading,
    addloading,
    onFinish,
    columns,
    jobDescription,
    setJobDescription,
    editingJobId,
    isCompensationEnabled,
    handleBudgetApprovalChange,
    departments,
    jobTitles,
    handleDepartmentChange,
    selectedDepartmentId,
     selectedJobTitle,
    handleJobTitleChange
     } = useHiring();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        className="card-professional"
        title="Job Postings"
        extra={
          <Link to="/viewcareer" className="underline-link">
            <div style={{ textDecoration: "underline", color: "white" }}>View Career Page</div>
          </Link>
        }
      >
        <Button
          className="btn-primary"
          onClick={showForm ? handleBackToList : handleAddJob}
          style={{ marginBottom: 20 }}
        >
          {showForm ? "Back to Job List" : "Add Job Posting"}
        </Button>

        {!showForm ? (
          <Table
            className="custom-table"
            columns={columns}
            loading={loading}
            dataSource={jobPostings}
            rowKey="key"
          />
        ) : (
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            <Row gutter={16}>
             <Col span={12}>
                <Form.Item
                  name="departmentId"
                  label="Department"
                  rules={[{ required: true, message: "Please select the department!" }]}
                >
                  <Select
                  showSearch
                  allowClear
                    placeholder="Select department"
                    value={selectedDepartmentId || undefined}
                    onChange={handleDepartmentChange}
              
                  >
                    {departments.map((dept) => (
                      <Option key={dept.id} value={String(dept.id)}>
                        {dept.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            <Col span={12}>
             <Form.Item 
               name="jobTitleId"
               label="Select Job Title"
               rules={[{ required: true, message:"Please select the JOb Title"}]}
             >
              <Select 
              showSearch
              allowClear
              value={selectedJobTitle || undefined}
              onChange={handleJobTitleChange}
              >
               {jobTitles.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
               ))}
              </Select>
             </Form.Item>
            </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="isBudgetApproved"
                  label="Budget Approved"
                  rules={[
                    {
                      required: true,
                      message: "Please select whether the budget is approved!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select budget approval"
                    onChange={handleBudgetApprovalChange}
                  >
                    <Option value="Yes">Yes</Option>
                    <Option value="No">No</Option>
                  </Select>
                </Form.Item>
              </Col>

             
               <Col span={12}>
                <Form.Item
                  name="employementType"
                  label="Employment Type"
                  rules={[{ required: true, message: "Please select employment type!" }]}
                >
                  <Select placeholder="Select employment type">
                    {EMPLOYMENT_TYPES.map((type) => (
                      <Option key={type} value={type}>
                        {type}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="maximumExperience"
                  label="Maximum Experience (years)"
                  rules={[{ required: true, message: "Please select maximum experience!" }]}
                >
                  <Select placeholder="Select experience level">
                    {EXPERIENCE_LEVELS.map((level) => (
                      <Option key={level} value={level}>
                        {level}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="compensation"
                  label="Compensation"
                  rules={[{ required: true, message: "Please input the compensation!" }]}
                >
                  <Select disabled={!isCompensationEnabled} placeholder="Select Compensation">
                    {COMPENSATION_RANGES.map((range) => (
                      <Option key={range} value={range}>
                        {range}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="jobType"
                  label="Job Type"
                  rules={[{ required: true, message: "Please select job type!" }]}
                >
                  <Select placeholder="Select job type">
                    <Option value="On-site">On-site</Option>
                    <Option value="Remote">Remote</Option>
                    <Option value="Hybrid">Hybrid</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="jobLocationType"
                  label="Job Location Type"
                  rules={[{ required: true, message: "Please select job location type!" }]}
                >
                  <Select placeholder="Select job location type">
                    {usStates.map((state) => (
                      <Option key={state} value={state}>
                        {state}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="jobInternalCode"
                  label="Job Internal Code"
                  rules={[{ required: true, message: "Please input the job internal code!" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="Job Description">
                  <ReactQuill
                        ref={quillRef}  
                    theme="snow"
                    placeholder="Enter job Description"
                    value={jobDescription}
                    onChange={setJobDescription}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="skills"
                  label="Skills"
                  rules={[{ required: true, message: "Skill is required!" }]}
                >
                  <Select mode="tags" placeholder="Add skills" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button className="btn-primary" htmlType="submit" loading={addloading} disabled={addloading}>
                {addloading
                  ? editingJobId
                    ? "Updating..."
                    : "Submitting..."
                  : editingJobId
                  ? "Update Job Posting"
                  : "Submit"}
              </Button>
            </Form.Item>
          </Form>
        )}
      </Card>
      <Footer />
    </DashboardLayout>
  );
};

export default JobPostingForm;
